import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';

const screenCode = 'COLLECTIONCATEGORY';

export function CollectionCatogoryListing(props){

    const [collectionCategories, setFactories] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });

    const contentRowNames = ["collectionCategoryCode", "collectionCategoryName", "isActive"]

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOLLECTIONCATEGORYLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITCOLLECTIONCATEGORY');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined
        });
        
         trackPromise(
            getAllcollectionCategories()
            )
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }
    

    async function getAllcollectionCategories(){
        
        var data = await services.getAll()
        destroyDataTable()
        setFactories(data)
        createDataTable()
    }

    function handleClick(collectioncategory) {
        props.history.push({
            pathname: '/CollectionCategoryMaster/addEdit',
            data: collectioncategory,
            edit: true
        })
    }

   
    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Collection Categories"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Categories"
                            path="/CollectionCategoryMaster/addEdit" />
                    <div className="card-body">
                       
                           
                       
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Category Code</th>
                                        <th>Category Name</th>
                                        <th>Status</th>
                                        {permissionList.isAddEditEnabled ? <th>Action</th> : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContent
                                        data={collectionCategories}
                                        hasEdit={permissionList.isAddEditEnabled}
                                        contentRowNames={contentRowNames}
                                        handleClick={handleClick} 
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    );
}


